/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Money_TitleInputs */

const vi_my_grower_report_money_title = /** @type {(inputs: My_Grower_Report_Money_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số tiền nhận được`)
};

/**

* @param {My_Grower_Report_Money_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_money_title = /** @type {((inputs?: My_Grower_Report_Money_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Money_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_money_title(inputs)
});